import moment from 'moment';

import DateTime from 'core/definitions/DateTime';

export const dateTimeCurrent = (): DateTime => new Date().toISOString();

export const dateTimeMinDateOfBirth = (): DateTime => moment.utc('1753-01-01').toISOString();

export const dateTimeMaxDateOfBirth = (): DateTime => {
    return moment.utc().startOf('day').subtract(18, 'years').toISOString();
};

export const MAX_AGE = 115;

export const dateTimeMinDateOfBirthPortal = (): DateTime => {
    return moment.utc().startOf('day').subtract(MAX_AGE, 'years').toISOString();
};
